import React, { Component } from 'react';
import Paper from 'material-ui/Paper';
import FlatButton from 'material-ui/FlatButton';
import Snackbar from 'material-ui/Snackbar';
import CopyToClipboard from 'react-copy-to-clipboard';
import _ from 'lodash';
import CodeIcon from 'material-ui/svg-icons/action/code';
import DownloadIcon from 'material-ui/svg-icons/file/file-download';
import GeneratingIcon from 'material-ui/svg-icons/image/timelapse';
import details from './details';

import './AvailableButton.css';

class AvailableButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      clipboardMessageShown: false,
      isGenerating: false,
    };
  }

  showClipboardMessage = () => {
    this.setState({
      clipboardMessageShown: true,
    });

    setTimeout(() => {
      this.setState({
        clipboardMessageShown: false,
      });
    }, 2000);
  }

  triggerDownload = () => {
    this.setState({
      isGenerating: true,
    });

    fetch(`${details.apiUrl}/render/?site_id=${this.props.context.id}&class_index=${this.props.i}&string=${this.props.ctaString}`).then(res => {
      return res.json();
    }).then(data => {
      if (_.has(data, 'url')) {
        window.location.href = `${details.baseUrl}${data.url}`;

        this.setState({
          isGenerating: false,
        });
      }
    });
  }

  render() {
    return (
      <div className="AvailableButton">
        <Paper style={{
          padding: '1em', 
          width: '100%', 
          flexGrow: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
        }}>
          <div className="AvailableButton__nest btn-container">
            <a href="#" style={{pointerEvents: 'none'}} className={this.props.ctaClass}>{this.props.ctaString}</a>
          </div>
          <div className="AvailableButton__actions">
            <FlatButton
              label={this.state.isGenerating ? 'Generating…' : 'Download'}
              icon={this.state.isGenerating ? <GeneratingIcon /> : <DownloadIcon />}
              onClick={this.triggerDownload}
            />
            <CopyToClipboard text={this.props.ctaClass} onCopy={this.showClipboardMessage}>
              <FlatButton
                label="Get Class"
                icon={<CodeIcon />}
              />
            </CopyToClipboard>
          </div>
          <Snackbar
            open={this.state.clipboardMessageShown}
            message="This class has been copied to your clipboard"
            autoHideDuration={2000}
          />
        </Paper>
      </div>
    );
  }
}

export default AvailableButton;



// WEBPACK FOOTER //
// ./src/AvailableButton.js